import { groupRideService } from 'src/services/GroupRide'
import { IActiveTripResponseV2, ISimpleDriverDTO } from 'src/types'
import * as constants from '../../constants'
import { createAction } from '../helpers'
import { updateTripOperatorPushNotification } from '../trips'
import { tripService } from 'src/services/Trip'

export const actionCreators = {
  assignOperatorRequest: () => createAction(constants.TRIP_ASSIGN_OPERATOR_REQUEST),
  assignOperatorSuccess: (trip: IActiveTripResponseV2) => createAction(constants.TRIP_ASSIGN_OPERATOR_SUCCESS, trip),
  assignOperatorFailure: (error: string) => createAction(constants.TRIP_ASSIGN_OPERATOR_FAIL, error)
}
export const assignOperator = (id: string, operator: ISimpleDriverDTO, tripId?: string) => {
  const { assignOperatorRequest, assignOperatorSuccess, assignOperatorFailure } = actionCreators
  return async (dispatch: any) => {
    let oldTrip: IActiveTripResponseV2 | null = null

    if (tripId) {
      oldTrip = await tripService.get(tripId)
    }

    dispatch(assignOperatorRequest())
    return groupRideService.assignOperator(id, operator).then(
      res => {
        dispatch(assignOperatorSuccess(res.data))
        const tripId = res && res.trips.length > 0 ? res.trips[0].id : null
        if (
          (oldTrip && oldTrip.operator && oldTrip.operator.id && oldTrip.operator.operatorId !== operator.operatorId) ||
          (oldTrip && oldTrip.operator === null && operator.operatorId)
        ) {
          dispatch(updateTripOperatorPushNotification(tripId))
        }

        return res.data
      },
      err => {
        dispatch(assignOperatorFailure(err.data))
        console.log('G', err.data)
        return err
      }
    )
  }
}

export const unAssignOperator = (id: string) => {
  const { assignOperatorRequest, assignOperatorSuccess, assignOperatorFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(assignOperatorRequest())
    return groupRideService.unAssignOperator(id).then(
      res => {
        dispatch(assignOperatorSuccess(res.data))
        return res.data
      },
      err => {
        dispatch(assignOperatorFailure(err.data))
        return err
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/group_ride/index.ts